import React from 'react';
import { Handle, Position, NodeResizer } from '@xyflow/react';
import { Box, Typography } from '@mui/material';

export default function SubAgentContainerNode({ data, selected }) {
  const { subAgents = [], onOpenCanvas } = data;
  return (
    <Box sx={{
      position: 'relative',
      border: '2px solid #a855f7',
      borderRadius: 2,
      minWidth: 160,
      width: '100%',
      height: '100%',
      bgcolor: 'background.paper',
      boxShadow: selected ? '0 0 0 3px #a855f744' : 1,
    }}>
      <NodeResizer minWidth={160} minHeight={60} isVisible={selected} color="#a855f7" />
      <Handle id="source-top" type="source" position={Position.Top} style={{ background: '#a855f7' }} />
      <Handle id="source-left" type="source" position={Position.Left} style={{ background: '#a855f7' }} />
      <Handle id="source-bottom" type="source" position={Position.Bottom} style={{ background: '#a855f7' }} />
      <Handle id="source-right" type="source" position={Position.Right} style={{ background: '#a855f7' }} />
      <Box sx={{ px: 1.5, py: 0.75, bgcolor: '#a855f722', borderRadius: '6px 6px 0 0', display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography sx={{ color: '#a855f7', fontWeight: 'bold', fontSize: 13 }}>@</Typography>
        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#a855f7', fontSize: 11 }}>Sub-Agents</Typography>
      </Box>
      <Box sx={{ px: 1.5, py: 0.75, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        {subAgents.length === 0
          ? <Typography variant="caption" sx={{ color: 'text.disabled', fontSize: 9 }}>No sub-agents</Typography>
          : subAgents.map((s) => (
            <Box key={s.agentName} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
              <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: 10, fontFamily: 'monospace' }}>
                @{s.agentName}
              </Typography>
              {onOpenCanvas && (
                <Typography
                  variant="caption"
                  sx={{ color: '#a855f7', fontSize: 9, cursor: 'pointer', whiteSpace: 'nowrap', '&:hover': { textDecoration: 'underline' } }}
                  onClick={(e) => { e.stopPropagation(); onOpenCanvas(s.agentName); }}
                >
                  ⊙ open
                </Typography>
              )}
            </Box>
          ))
        }
      </Box>
    </Box>
  );
}
